import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const QRCODE_URL = 'https://x0.ifengimg.com/ucms/2026_37/EC2D88D9FED3113682F9D5D46ABD7099FD688E4B_size11_w400_h400.png';

class Finance extends React.PureComponent {
    state = {
        showQrMask: false,
    };

    openQrMask = () => {
        this.setState({ showQrMask: true });
    };

    closeQrMask = () => {
        this.setState({ showQrMask: false });
    };

    preventClose = (e) => {
        e.stopPropagation();
    };

    render() {
        const { showQrMask } = this.state;

        return (
            <div className={styles.financeAd}>
                <div className={styles.financeAdText} onClick={this.openQrMask}>
                    投资、理财、买保险遇陷阱投诉无门？来百灵投诉！
                </div>
                <div className={styles.financeAdPic} onClick={this.openQrMask}>
                    <img src="https://x0.ifengimg.com/ucms/2026_23/60EFBA1DF3F1F3317636E5C418E7DB21A28A7F48_size475_w2544_h413.png" />
                </div>
                {showQrMask ? (
                    <div className={styles.qrMask} onClick={this.closeQrMask}>
                        <div className={styles.qrMaskContent} onClick={this.preventClose}>
                            <div className={styles.qrMaskPanel}>
                                <div className={styles.qrMaskHead}>
                                    <div className={styles.qrMaskHeadTitle}>百灵投诉</div>
                                    <div className={styles.qrMaskHeadSub}>投资、理财、买保险遇陷阱来百灵投诉</div>
                                </div>
                                <div className={styles.qrMaskBody}>
                                    <div className={styles.qrMaskQrWrap}>
                                        <img className={styles.qrMaskImage} src={QRCODE_URL} alt="百灵小程序二维码" />
                                    </div>
                                    <div className={styles.qrMaskTip}>请使用手机扫码进入百灵小程序</div>
                                </div>
                            </div>
                            <div className={styles.qrMaskClose} onClick={this.closeQrMask} />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default errorBoundary(Finance);
